import VoiceActivityDetection from './VoiceActivityDetection';

export default VoiceActivityDetection;
